/** Допустимые символы локальной части и домена e-mail */
const EMAIL_CHAR = /[a-zA-Z0-9._%+-@]/

/**
 * Очистка ввода: без пробелов, только допустимые символы, нижний регистр, один «@».
 */
export function sanitizeEmailInput(value) {
  let s = String(value ?? '').replace(/\s/g, '')
  let out = ''
  for (const ch of s) {
    if (EMAIL_CHAR.test(ch)) out += ch
  }
  out = out.toLowerCase()
  const at = out.indexOf('@')
  if (at === -1) return out
  const local = out.slice(0, at)
  const domain = out.slice(at + 1).replace(/@/g, '')
  return `${local}@${domain}`
}

/** Нормализация перед отправкой на API */
export function normalizeEmail(value) {
  return sanitizeEmailInput(value)
}

/** Практичная проверка формата (не полный RFC). */
export function isEmailFormatValid(value) {
  const e = normalizeEmail(value)
  if (!e || e.length > 254) return false
  return /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(e)
}

export function isEmailCharAllowed(char) {
  return char.length === 1 && EMAIL_CHAR.test(char)
}
